import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getSchemas } from './schema';

export default function SchemaInjector() {
  const location = useLocation();

  useEffect(() => {
    document
      .querySelectorAll('script[data-seo-jsonld]')
      .forEach((s) => s.remove());

    const schemas = getSchemas(location.pathname);
    schemas.forEach((schema) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-seo-jsonld', 'true');
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    });
  }, [location.pathname]);

  return null;
}